import { useEffect, useRef, useState } from 'react';

const TRAIL_COUNT = 8;

export default function CustomCursor() {
  const [isTouch] = useState(() => window.matchMedia('(pointer: coarse)').matches);
  const dotsRef = useRef([]);
  const positionsRef = useRef(
    Array.from({ length: TRAIL_COUNT }, () => ({ x: -400, y: -400 }))
  );
  const targetRef = useRef({ x: -400, y: -400 });
  const frameRef = useRef(null);

  useEffect(() => {
    const factors = Array.from({ length: TRAIL_COUNT }, (_, i) => 0.30 - i * 0.025);

    const tick = () => {
      const target = targetRef.current;
      for (let i = 0; i < TRAIL_COUNT; i++) {
        const prev = i === 0 ? target : positionsRef.current[i - 1];
        const pos = positionsRef.current[i];
        pos.x += (prev.x - pos.x) * factors[i];
        pos.y += (prev.y - pos.y) * factors[i];

        const el = dotsRef.current[i];
        if (el) {
          el.style.transform = `translate(calc(${pos.x}px - 50%), calc(${pos.y}px - 50%))`;
        }
      }
      frameRef.current = requestAnimationFrame(tick);
    };

    frameRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameRef.current);
  }, []);

  useEffect(() => {
    const onMove = (e) => {
      targetRef.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  if (isTouch) return null;

  return (
    <>
      {Array.from({ length: TRAIL_COUNT }, (_, i) => {
        const size = Math.max(2, 8 - i * 0.7);
        const alpha = 1 - i * 0.1;
        const color = i < 4
          ? `rgba(26,111,255,${alpha})`
          : `rgba(0,217,168,${(alpha * 0.8).toFixed(2)})`;

        return (
          <div
            key={i}
            ref={(el) => { dotsRef.current[i] = el; }}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: size,
              height: size,
              borderRadius: '50%',
              background: color,
              pointerEvents: 'none',
              zIndex: 9999 - i,
              filter: i > 3 ? `blur(${(i - 3) * 0.5}px)` : 'none',
            }}
          />
        );
      })}
    </>
  );
}
